import { RouteProps } from 'react-router'
import { lazy } from 'react'
import { isDev } from '../../../common/business/isDev'
import { devWebRouteList } from './devWebRouteList'

export const routerMobile = ([
    {
        path: '/',
        component: lazy(() => import('../../../example/hello')),
        exact: true,
    },
    {
        path: '/distribution',
        component: lazy(() => import('../../../pages/distribution')),
    },
    {
        path: '/pdfView',
        component: lazy(() => import('../../../pages/pdfViewPage')),
        // meta: {
        //     title: '依据文件',
        // },
    },
    {
        path: '/reportList',
        component: lazy(() => import('../../../pages/reportList')),
    },
    {
        //检疫登录页面
        path: '/quarantine',
        component: lazy(() => import('../../../pages/quarantine/login/index')),
        exact: true,
    },
    {
        // 检疫报告列表
        path: '/quarantine/list',
        component: lazy(() => import('../../../pages/quarantine/reportList/index')),
    },
    {
        // 检疫报告详情
        path: '/quarantine/detail',
        component: lazy(() => import('../../../pages/quarantine/reportDetail/index')),
    },
] as RouteProps[]).concat(isDev() ? devWebRouteList : [])
